import { AnalyticsEvent } from "./analyticsEvent"
class EnquiryFormSubmissionInteractionEvent extends AnalyticsEvent {
    public dropdownName: string;
    constructor(dropdownValue: string) {
        super();
        this.dropdownName = dropdownValue;
    }
}
export { EnquiryFormSubmissionInteractionEvent }